function generateId(prefix = "id") {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
  }
  
  export function getVisitorId() {
    let visitorId = localStorage.getItem("visitorId");
  
    if (!visitorId) {
      visitorId = generateId("visitor");
      localStorage.setItem("visitorId", visitorId);
    }
  
    return visitorId;
  }
  
  export function getSessionId() {
    let sessionId = sessionStorage.getItem("sessionId");
  
    if (!sessionId) {
      sessionId = generateId("session");
      sessionStorage.setItem("sessionId", sessionId);
    }
  
    return sessionId;
  }
  
  export function getTodayString(date = new Date()) {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  }